module.exports = __webpack_public_path__ + "static/media/bannerlogo.8e626c61.png";